module.exports = __webpack_public_path__ + "img/P1010722.26092a2c.jpg";